jQuery(function ($) {

	/**
	 * functions
	 */
	const $hamburger = jQuery('.js-hamburger');
	const $navigation = jQuery('.js-navigation');
	function openNavigation() {
		$hamburger.addClass('js-hamburger-active');
		$navigation.addClass('js-navigation-active');
	}

	function closeNavigation() {
		$hamburger.removeClass('js-hamburger-active');
		$navigation.removeClass('js-navigation-active');
		$navigation.find('.js-sub-menu-icon').addClass('jam-plus');
		$navigation.find('.sub-menu').addClass('hidden');
		$navigation.find('.menu-item-has-children').removeClass('bg-steel-gray');
		$navigation.find('.menu-item-has-children').removeClass('bg-steel-gray');
	}


	/**
	 * hamburger
	 */

	$hamburger.on('click', function () {
		if (jQuery(this).hasClass('js-hamburger-active')) {
			closeNavigation();
		} else {
			openNavigation();
		}
	});


	/**
	 * navigation menu
	 */

	// add plus icon if a menu has children (shown on mobile)
	$navigation.find('.menu-item-has-children').children('a').append('<span class="js-sub-menu-icon md:hidden jam jam-plus jam-minus text-black absolute right-0 -mr-8 text-2xl z-999"></span>');

	// add arrow down icon if a menu has children (shown on desktop)
	$navigation.find('.menu-item-has-children').children('a').append('<span class="hidden md:block jam jam-chevron-down text-black text-2xl"></span>');

	// show sub menu when clicking the plus icon
	jQuery('.js-sub-menu-icon').on('click', function (e) {
		e.preventDefault();
		jQuery(this).toggleClass('jam-plus');
		jQuery(this).parents('li').find('.sub-menu').toggleClass('hidden');
		jQuery(this).parents('li').toggleClass('bg-whisper');
	});


	/**
	 * navigation menu responsive
	 */

	// hide sub menu when mobile
	jQuery(window).on('lessThan-md', function () {
		jQuery('.menu-item-has-children').children('.sub-menu').addClass('hidden');
	});

	// remove hide class as it triggers on hover when dekstop
	jQuery(window).on('greaterEqualTo-md', function () {
		jQuery('.menu-item-has-children').children('.sub-menu').removeClass('hidden');
		$navigation.find('.menu-item-has-children').removeClass('bg-whisper');
	});
});


